var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcViewProspectDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "15px",
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icViewProspectDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-43.3%",
    y: "-65.0%",
    width: "186.7%",
    height: "230.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.426545516 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.6643519,3.52972707 C14.8808113,3.74779554 14.9999998,4.03911264 14.9999998,4.34981362 C15.0001809,4.66070097 14.8809924,4.95201808 14.6645331,5.17027293 C13.6112183,6.23153948 10.8046733,8.7 7.5,8.7 C4.1951456,8.7 1.38878172,6.23172587 0.335648066,5.17045932 C0.119007569,4.95220446 -0.000180931379,4.66088736 2.06160075e-07,4.35 C2.06160075e-07,4.03911264 0.119188707,3.74798192 0.335648066,3.52991345 C1.38878172,2.4686469 4.19532674,8.8817842e-15 7.5,8.8817842e-15 C10.8044921,8.8817842e-15 13.6110371,2.46846052 14.6643519,3.52972707 Z M7.5,1.74268392 C6.10270503,1.74268392 4.96606697,2.91223917 4.96606697,4.35 C4.96606697,5.78776083 6.10270503,6.95731608 7.5,6.95731608 C8.89729497,6.95731608 10.033933,5.78776083 10.033933,4.35 C10.033933,2.91223917 8.89711384,1.74268392 7.5,1.74268392 Z M7.5,6.14338018 C6.53906536,6.14338018 5.7570946,5.33876344 5.7570946,4.35 C5.7570946,3.36123656 6.53888422,2.55661982 7.5,2.55661982 C8.46111578,2.55661982 9.2429054,3.36105017 9.2429054,4.35 C9.2429054,5.33894983 8.46093464,6.14338018 7.5,6.14338018 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GRID-MODE_Prospect-Viewed-me",
    transform: "translate(-698.000000, -333.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/UserProfileThumb-Desktop-Copy-26",
    transform: "translate(691.000000, 322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/UserProfileThumb-Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Close-Icon",
    filter: "url(#filter-1)",
    transform: "translate(10.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(0.000000, 0.300000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icViewProspectDesktop",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewProspectDesktop);
export default __webpack_public_path__ + "static/media/icViewProspectDesktop.555cb1a7bd4d60452ffa98a58021a76a.svg";
export { ForwardRef as ReactComponent };